module.exports = __webpack_public_path__ + "img/tenglong03.432c4554.png";